<flo-node-list
  [props]="nodeListComponentProps$ | async"
  (action$)="action$.next($event)"
></flo-node-list>
